export const createMarkerTemplate = item => {
	const template = document
		.getElementById('marker-template')
		.content.cloneNode(true)
	const markerElement = template.querySelector('[data-marker]')

	markerElement.innerText = item.number
	return markerElement
}

export const createSearchMarkerTemplate = item => {
	const template = document
		.getElementById('marker-template')
		.content.cloneNode(true)
	const markerElement = template.querySelector('[data-marker]')

	template.querySelector('[data-marker-inner]').innerText = item.price

	return markerElement
}

export const createSearchPopupTemplate = item => {
	const template = document
		.getElementById('popup-template')
		.content.cloneNode(true)

	const popupElement = template.querySelector('[data-popup]')
	const photoElement = popupElement.querySelector('[data-popup-photo]')
	const starsElement = popupElement.querySelector('[data-popup-stars]')
	const reviewPhraseElement = popupElement.querySelector(
		'[data-popup-review-phrase]'
	)
	const reviewsCountElement = popupElement.querySelector(
		'[data-popup-reviews-count]'
	)
	const nameElement = popupElement.querySelector('[data-popup-name]')
	const ratingElement = popupElement.querySelector('[data-popup-rating]')
	const biggerPriceElement = popupElement.querySelector(
		'[data-popup-bigger-price]'
	)
	const priceElement = popupElement.querySelector('[data-popup-price]')

	if (item.photo) photoElement.src = item.photo

	if (item.stars > 1) {
		const starElement = starsElement.querySelector('svg')
		for (let i = 1; i < item.stars; i++) {
			starsElement.appendChild(starElement.cloneNode(true))
		}
	} else {
		starsElement.style.display = 'none'
	}

	if (item.reviewsCount > 0 || item.rating > 0) {
		reviewPhraseElement.textContent = item.reviewPhrase

		if (item.reviewsCount > 0) {
			reviewsCountElement.textContent = item.reviewsCount
		} else {
			reviewsCountElement.parentElement.style.display = 'none'
		}
	} else {
		reviewPhraseElement.parentElement.style.display = 'none'
	}

	nameElement.textContent = item.name
	ratingElement.textContent = item.rating
	biggerPriceElement.textContent = item.biggerPrice
	priceElement.textContent = item.price

	return popupElement
}
